import { useEffect, useState } from "react";
import {Drawer, Button, message, ConfigProvider} from "antd";
import {LeftOutlined, RightOutlined} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import useFetchProducts from "../../hooks/useFetchProducts";
import { categorizeProducts } from "../../utils/CategorizeProducts";
import ContactUs from "../ContactUs/ContactUs";
import { useSideMenu } from "../../context/SideMenuContext";
import useIsMobile from "../../hooks/useIsMobile.js";

const SideMenu = () => {
    const { isOpen, closeMenu } = useSideMenu();
    const [openCategory, setOpenCategory] = useState(null);
    const [openSubCategory1, setOpenSubCategory1] = useState(null);
    const [openSubCategory2, setOpenSubCategory2] = useState(null);
    const { products, error } = useFetchProducts();
    const { t } = useTranslation("optPage");
    const navigate = useNavigate();

    const isMobile = useIsMobile();

    const resetView = () => {
        setOpenCategory(null);
        setOpenSubCategory1(null);
        setOpenSubCategory2(null);
    };

    const handleCategoryClick = (category) => {
        setOpenCategory(category);
        setOpenSubCategory1(null);
        setOpenSubCategory2(null);

        if (!categories[category] || Object.keys(categories[category]).length === 0) {
            closeMenu();
        }

        navigate(`/products/${category}`);
    };

    const handleSubCategoryClick = (subCategoryLevel, subCategory) => {
        if (subCategoryLevel === 1) {
            setOpenSubCategory1(subCategory);
            setOpenSubCategory2(null);

            if (!categories[openCategory][subCategory] || Object.keys(categories[openCategory][subCategory]).length === 0) {
                closeMenu();
            }

            navigate(`/products/${openCategory}/${subCategory}`);
        } else if (subCategoryLevel === 2) {
            setOpenSubCategory2(subCategory);

            closeMenu();

            navigate(`/products/${openCategory}/${openSubCategory1}/${subCategory}`);
        }
    };

    const handleBackClick = () => {
        if (openSubCategory2) {
            setOpenSubCategory2(null);
            navigate(`/products/${openCategory}/${openSubCategory1}`);
        } else if (openSubCategory1) {
            setOpenSubCategory1(null);
            navigate(`/products/${openCategory}`);
        } else if (openCategory) {
            setOpenCategory(null);
            navigate(`/`);
        }
    };

    const categories = categorizeProducts(products);

    useEffect(() => {
        if (
            openCategory &&
            Object.keys(categories[openCategory]).length === 1 &&
            Object.prototype.hasOwnProperty.call(categories[openCategory], "products")
        ) {
            closeMenu();
        }

        if (
            openSubCategory1 &&
            Object.keys(categories[openCategory][openSubCategory1]).length === 1 &&
            Object.prototype.hasOwnProperty.call(categories[openCategory][openSubCategory1], "products")
        ) {
            closeMenu();
        }
    }, [openCategory, openSubCategory1, categories, closeMenu]);

    useEffect(() => {
        resetView();
    }, [isOpen]);

    if (error) return message.error(error.message);


    return (
        <Drawer
            placement="left"
            onClose={closeMenu}
            open={isOpen}
            width={isMobile ? "100vw" : 382}
            closeIcon={null}
            rootStyle={{ top: 64 }}
        >
            {(openCategory || openSubCategory1 || openSubCategory2) && (

                <ConfigProvider
                    theme={{
                        components: {
                            Button: {
                                paddingInlineLG: 0
                            },
                        },
                    }}
                >
                    <div className="flex flex-col w-full items-start">
                        <Button
                            color="default"
                            type="link"
                            size="large"
                            icon={
                                <LeftOutlined
                                    style={{
                                        color: "black"
                                    }}
                                />
                            }
                            onClick={handleBackClick}
                            iconPosition="start"
                        >
                            <div className="text-black font-medium text-xl">{t("back")}</div>
                        </Button>

                        <Button
                            color="default"
                            type="link"
                            size="large"
                            icon={
                                <RightOutlined
                                    style={{
                                        color: "black"
                                    }}
                                />
                            }
                            onClick={closeMenu}
                            iconPosition="start"
                        >
                            <div className="text-black font-medium text-xl">{t("expandMenu")}</div>
                        </Button>
                    </div>
                </ConfigProvider>
            )}

            {!openCategory &&
                Object.keys(categories).map((category) => (
                    <div
                        key={category}
                        onClick={() => handleCategoryClick(category)}
                        className="mt-4 text-lg font-medium text-black py-2 px-0 cursor-pointer"
                    >
                        {category}
                    </div>
                ))}

            {openCategory &&
                !openSubCategory1 &&
                Object.keys(categories[openCategory])
                    .filter((key) => key !== "products")
                    .map((subCategory1) => (
                        <div
                            key={subCategory1}
                            onClick={() => handleSubCategoryClick(1, subCategory1)}
                            className="text-lg font-medium text-black py-2 px-0 cursor-pointer"
                        >
                            {subCategory1}
                        </div>
                    ))}

            {openSubCategory1 &&
                !openSubCategory2 &&
                Object.keys(categories[openCategory][openSubCategory1])
                    .filter((key) => key !== "products")
                    .map((subCategory2) => (
                        <div
                            key={subCategory2}
                            onClick={() => handleSubCategoryClick(2, subCategory2)}
                            className="text-lg font-medium text-black py-2 px-0 cursor-pointer"
                        >
                            {subCategory2}
                        </div>
                    ))}

            <ContactUs />
        </Drawer>
    );
};

export default SideMenu;